import moment from "moment-timezone";

// Load locales
moment.locale("ru", require("moment/locale/ru"));
moment.locale("pl", require("moment/locale/pl"));
moment.locale("es", require("moment/locale/es"));
moment.locale("de", require("moment/locale/de"));

export const setTimeZone = (timeZone) => {
  moment.tz.setDefault(timeZone);
};

export const getTimeZone = () => {
  return moment.tz.guess();
};

export default moment;
